export enum DocumentRequestDetailState {
    SENT="SENT",
    NOT_SENT="NOT_SENT"
}